import React, { useEffect } from "react";
import { NoFeedIcon } from "../Icons/icons.component";
import Loader from "../Shared/Loader";
import "../../components/Topics/topics.sass";
import { DATE_FORMATS,COOKIE } from "../../constants/app-constant";
import { formatDate } from "../../utility/common-methods";
import { useSelector } from "react-redux";
import { getCookie } from "../../utility/cookieProvider";
import ReactGA from "react-ga4";
import {GACODE} from "../../constants/app-constant";

const { DDMMYYYY_dash } = DATE_FORMATS;
const cilClientList = [
  "CIL",
  "Pralhad Joshi",
  "Central Coalfields Ltd",
  "Eastern Coalfields Ltd",
  "Western Coalfields Ltd",
  "Northern Coalfields Ltd",
  "South Eastern Coalfields Ltd",
  "Mahanadi Coalfields Ltd",
  "Central Mine Planning and Design Institute",
  "Singareni Collieries Company Ltd",
  "Bharat Coking Coal Ltd",
];
export const EntityList = ({ setShowAddTopic, setEditData }) => {
  ReactGA.initialize(GACODE);

  const entityState = useSelector(
    (state) => state.entityAndKeyWordsReducer || {}
  );
  const { socialEntityList } = entityState || [];
  const selectedClient = useSelector(
    (state) => state.clientReducer.selectedClient || {}
  );
  // const disabled = selectedClient && selectedClient.client_name === "CIL";
  const disabled =
    selectedClient && cilClientList.indexOf(selectedClient.client_name) === -1
      ? false
      : true;

  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.set({ userId: selectedClient.id+".0."+concept_uid });
    ReactGA.set({ 'user_id': selectedClient.id+".0."+concept_uid });
  }        

  let locationHrefNew = window.location.href;
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.event({
      category: "Profile Entity",
      action: "Profile Entity - "+selectedClient.id+".0."+concept_uid,
      label: locationHrefNew, // optional
      //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
    });
  }

  return (
    <>
      <div className="entityDetailsWrap">
        {!socialEntityList && <Loader />}
        {socialEntityList && socialEntityList.length ? (
          <table className="table customTableTwo entitiesListingTable">
            <thead>
              <tr className="topicRow">
                <th className="thEntityName">Entities</th>
                <th className="thDateAdded">Date Added</th>
              </tr>
            </thead>
            <tbody>
              {socialEntityList.map((row) => {
                const { id, name, created_at } = row || {};
                return (
                  <tr key={id}>
                    <td
                      onClick={() => {
                        if (!disabled) {
                          setEditData(row);
                          setShowAddTopic(true);
                        }
                      }}
                    >
                      <strong className="clickable">{name}</strong>
                    </td>
                    <td>{formatDate(created_at, DDMMYYYY_dash)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          socialEntityList && (
            <div className="noFilterDataWrap">
              <NoFeedIcon />
              <h6>No Entinties Found</h6>
              <p></p>
            </div>
          )
        )}
      </div>
    </>
  );
};
